import { nu, type Digits } from './digits.ts';
import type { Locale } from '../locale.ts';

const cache = new Map<string, Intl.NumberFormat>();
function nf(locale: Locale, digits: Digits, opts: Intl.NumberFormatOptions = {}) {
  const tag = `${locale === 'fa' ? 'fa-IR' : 'en-US'}-u-nu-${nu(digits)}`;
  const key = tag + JSON.stringify(opts);
  let f = cache.get(key);
  if (!f) cache.set(key, (f = new Intl.NumberFormat(tag, opts)));
  return f;
}

export function formatNumber(n: number, locale: Locale, digits: Digits, opts?: Intl.NumberFormatOptions): string {
  return nf(locale, digits, opts).format(n);
}

export function formatPercent(ratio: number, locale: Locale, digits: Digits, fractionDigits = 0): string {
  return nf(locale, digits, { style: 'percent', maximumFractionDigits: fractionDigits }).format(ratio);
}

export function formatDistance(meters: number, locale: Locale, digits: Digits): string {
  if (meters < 1000) return `${formatNumber(Math.round(meters), locale, digits)} ${locale === 'fa' ? 'متر' : 'm'}`;
  const km = meters / 1000;
  return `${formatNumber(km, locale, digits, { maximumFractionDigits: km < 10 ? 1 : 0 })} ${locale === 'fa' ? 'کیلومتر' : 'km'}`;
}
